import { push } from "connected-react-router";

import * as blueprintReducer from "containers/Blueprint/reducer";
import * as viewReducer from "containers/View/reducer";
import * as homeReducer from "containers/Home/reducer";
import * as consumerReducer from "containers/Consumer/reducer";
import * as nextReducer from "containers/Next/NextReducer";

export const UPDATE_FIELD = "tour/UPDATE_FIELD";
export const RESET = "tour/RESET";

const initialState = {
  isOpen: false,
  step: 0
};

function tourReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FIELD:
      return {
        ...state,
        [action.key]: action.data
      };
    case RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
}

/* Selectors */
export function getBase(state) {
  return state.tour;
}

export function getIsOpen(state) {
  return getBase(state).isOpen;
}

export function getIsOpenSense(state) {
  return getBase(state).isOpenSense;
}

export function getIsOpenExplore(state) {
  return getBase(state).isOpenExplore;
}

export function getIsOpenNewChat(state) {
  return getBase(state).isOpenNewChat;
}

export function getStep(state) {
  return getBase(state).step;
}

export function getCollaborateStep(state) {
  return getBase(state).stepCollaborate;
}

export function getHasTour(state) {
  const tourBlueprint =
    blueprintReducer.getBlueprint(state, 12100) !== undefined ||
    blueprintReducer.getBlueprint(state, 979) !== undefined;

  const tourDataset =
    homeReducer.getDataset(state, 2190) !== undefined || homeReducer.getDataset(state, 1181) !== undefined;

  return tourBlueprint && tourDataset;
}

export function getCollaborateIsOpen(state) {
  return getBase(state).isOpenCollaborate;
}

/* Actions */
export function updateIsOpen(isOpen) {
  return (dispatch, getState) => {
    if (isOpen === true) {
      dispatch(updateStep(0));

      dispatch(viewReducer.updateType("blueprints"));
      dispatch(viewReducer.updateIsTile(true));
      dispatch(push("/"));
    }

    return dispatch({ type: UPDATE_FIELD, data: isOpen, key: "isOpen" });
  };
}

export function updateIsOpenSense(isOpenSense) {
  return (dispatch, getState) => {
    if (isOpenSense === true) {
      dispatch(viewReducer.updateType("datasets"));
      dispatch(updateStep(0));
    }

    return dispatch({ type: UPDATE_FIELD, data: isOpenSense, key: "isOpenSense" });
  };
}

export function updateIsOpenNewChat(isOpenNewChat) {
  return (dispatch, getState) => {
    if (isOpenNewChat === true) {
      dispatch(updateStep(0));
    }

    return dispatch({ type: UPDATE_FIELD, data: isOpenNewChat, key: "isOpenNewChat" });
  };
}

export function updateIsOpenExplore(isOpenExplore) {
  return (dispatch, getState) => {
    if (isOpenExplore === true) {
      const nextId = nextReducer.getCurrentNextId(getState());
      dispatch(nextReducer.resetActions(nextId));
      dispatch(updateStep(0));
    }

    return dispatch({ type: UPDATE_FIELD, data: isOpenExplore, key: "isOpenExplore" });
  };
}

export function updateStep(step) {
  return { type: UPDATE_FIELD, data: step, key: "step" };
}

export function updateCollaborateTourIsOpen(isOpen) {
  return (dispatch, getState) => {
    if (isOpen === true) {
      dispatch(updateCollaborateStep(0));

      dispatch(consumerReducer.updateMode("DATA"));
      dispatch(push("/collaborate/"));
    }

    return dispatch({ type: UPDATE_FIELD, data: isOpen, key: "isOpenCollaborate" });
  };
}

export function updateCollaborateStep(step) {
  return { type: UPDATE_FIELD, data: step, key: "stepCollaborate" };
}

export default tourReducer;
